module.exports = __webpack_public_path__ + "img/Candella_4_small.ba229c63.jpg";